if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        this.destroyProductModalSwiper();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        const init = () => this.initProductModalSwiper();
        if (typeof window.ensureThemeSwiper === 'function') {
          window
            .ensureThemeSwiper()
            .then(init)
            .catch(() => {});
        } else {
          init();
        }
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('active'));
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        activeMedia.classList.add('active');

        const isCarousel = this.querySelector('.product-media-modal-swiper');
        if (!isCarousel) {
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          if (container && activeMedia.width) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        const deferredMedia = activeMedia.querySelector && activeMedia.querySelector('deferred-media, product-model');
        const template = deferredMedia && deferredMedia.querySelector('template');
        const templateContent = template ? template.content : null;
        if (
          deferredMedia &&
          templateContent &&
          templateContent.querySelector &&
          templateContent.querySelector('.js-youtube')
        ) {
          deferredMedia.loadContent && deferredMedia.loadContent();
          this._playModalVideo(activeMedia);
        }
      }

      _playModalVideo(container) {
        if (!container) return;
        const youtube = container.querySelector('.js-youtube');
        if (youtube?.contentWindow) {
          try {
            youtube.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } catch (_) {}
          return;
        }
        const vimeo = container.querySelector('.js-vimeo');
        if (vimeo?.contentWindow) {
          try {
            vimeo.contentWindow.postMessage('{"method":"play"}', '*');
          } catch (_) {}
          return;
        }
        const video = container.querySelector('video');
        if (video?.getAttribute('autoplay')) {
          video.play().catch(() => {});
        }
      }

      getProductModalSectionId() {
        if (!this.id || this.id.indexOf('ProductModal-') !== 0) return null;
        return this.id.replace('ProductModal-', '');
      }

      initProductModalSwiper() {
        const swiperEl = this.querySelector('.product-media-modal-swiper');
        if (!swiperEl || typeof Swiper === 'undefined') return;

        this.destroyProductModalSwiper();

        const sectionId = this.getProductModalSectionId();
        if (!sectionId) return;

        const activeSlide = this.querySelector('.swiper-slide.active');
        const slides = this.querySelectorAll('.product-media-modal-swiper .swiper-slide');
        let initialSlide = activeSlide ? Array.prototype.indexOf.call(slides, activeSlide) : 0;
        if (initialSlide < 0) initialSlide = 0;

        const nextEl = `.swiper-next-button-product-modal-${sectionId}`;
        const prevEl = `.swiper-prev-button-product-modal-${sectionId}`;

        const thumbsEl = this.querySelector('.product-media-modal-thumbs');
        let thumbsSwiper = null;
        if (thumbsEl && thumbsEl.querySelectorAll('.swiper-slide').length > 0) {
          const isDesktop = window.matchMedia('(min-width: 750px)').matches;
          thumbsSwiper = new Swiper(thumbsEl, {
            spaceBetween: 8,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true,
            centerInsufficientSlides: isDesktop,
            scrollbar: {
              el: thumbsEl.querySelector('.swiper-scrollbar'),
              hide: false,
              draggable: true,
            },
          });
          this._productModalThumbsSwiper = thumbsSwiper;

          thumbsEl.querySelectorAll('.product-media-modal__thumb').forEach((thumb) => {
            thumb.addEventListener('click', () => {
              const index = parseInt(thumb.dataset.index, 10);
              if (!isNaN(index) && this._productModalSwiper) this._productModalSwiper.slideTo(index);
            });
          });

          this._updateThumbsTrackIndicator(thumbsSwiper);
          thumbsSwiper.on('progress setTranslate', () => this._updateThumbsTrackIndicator(thumbsSwiper));
        }

        this._productModalSwiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: initialSlide,
          speed: 300,
          loop: false,
          grabCursor: true,
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
            disabledClass: 'swiper-button-disabled',
          },
          keyboard: { enabled: true },
          a11y: { prevSlideMessage: 'Previous', nextSlideMessage: 'Next' },
          thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : {},
          on: {
            slideChange: () => {
              this.updateProductModalThumbsActive();
            },
          },
        });

        this.updateProductModalThumbsActive();
        if (thumbsSwiper) {
          thumbsSwiper.slideTo(initialSlide, 0);
          this._updateThumbsTrackIndicator(thumbsSwiper);
        }
      }

      _updateThumbsTrackIndicator(thumbsSwiper) {
        const track = this.querySelector('.product-media-modal-thumbs__track');
        const thumb = track && track.querySelector('.product-media-modal-thumbs__track-thumb');
        if (!track || !thumb || !thumbsSwiper) return;

        const size = thumbsSwiper.width;
        const total = thumbsSwiper.virtualSize;
        const progress = thumbsSwiper.progress;
        const ratio = total > 0 ? Math.min(size / total, 1) : 1;
        const widthPercent = ratio * 100;
        const leftPercent = total > size ? progress * (100 - widthPercent) : 0;

        thumb.style.width = `${widthPercent}%`;
        thumb.style.left = `${leftPercent}%`;
        thumb.style.transform = 'none';
      }

      updateProductModalThumbsActive() {
        const mainSwiper = this._productModalSwiper;
        if (!mainSwiper) return;
        this.querySelectorAll('.product-media-modal__thumb').forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === mainSwiper.activeIndex);
        });
      }

      destroyProductModalSwiper() {
        if (this._productModalThumbsSwiper && typeof this._productModalThumbsSwiper.destroy === 'function') {
          this._productModalThumbsSwiper.destroy(true, true);
          this._productModalThumbsSwiper = null;
        }
        if (this._productModalSwiper && typeof this._productModalSwiper.destroy === 'function') {
          this._productModalSwiper.destroy(true, true);
          this._productModalSwiper = null;
        }
      }
    },
  );
}
